import { gql } from "@apollo/client";

const LEAGUEATHLETES = gql`
  query leagueAthletes($id: ID!) {
    leagueAthletes(id: $id)
  }
`;

export default LEAGUEATHLETES;
